import stateApi from '@/api/stateApi';
import DbDetailsStats from '@/components/dbDetailsStats';
import InspectBreadcrumbs from '@/components/inspectBreadcrumbs';
import InspectTabs from '@/components/inspectTabs';
import { InspectTabsSearchParams } from '@/lib/inspectLocation';
import { addRecentEntity } from '@/lib/recentEntities';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/inspect/$db/')({
  component: RouteComponent,
  validateSearch: InspectTabsSearchParams,
});

function RouteComponent() {
  const { db } = Route.useParams();

  const database = stateApi.mergedCollections.useStore((dbs) => {
    return dbs.find((x) => x.db === db);
  });

  useEffect(() => {
    if (db) {
      addRecentEntity(db);
    }
  }, [db]);

  return (
    <InspectTabs
      key={db}
      db={db}
      header={
        database && (
          <>
            <InspectBreadcrumbs db={database.db} />

            <DbDetailsStats db={database} />
          </>
        )
      }
    />
  );
}
